export default __webpack_public_path__ + "static/media/010.e8b6379f.jpg";